import { cn } from "@/utils/cn";
import { toChoiceOption } from "@/types/offer";
import type { MultiChoiceStep as MultiChoiceStepConfig } from "@/types/offer";
import type { StepRenderProps } from "./types";

const KEYS = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";

export function MultiChoiceStep({
  step,
  value,
  onChange,
}: StepRenderProps<MultiChoiceStepConfig>) {
  const selected = Array.isArray(value) ? (value as string[]) : [];

  const toggle = (val: string) => {
    const next = selected.includes(val)
      ? selected.filter((v) => v !== val)
      : [...selected, val];
    onChange(next);
  };

  return (
    <div role="group" aria-label={step.title} className="flex flex-col gap-3">
      {step.options.map((opt, i) => {
        const o = toChoiceOption(opt);
        const isSelected = selected.includes(o.value);
        return (
          <button
            type="button"
            key={o.value}
            role="checkbox"
            aria-checked={isSelected}
            className={cn("r1-choice", isSelected && "r1-choice-selected")}
            onClick={() => toggle(o.value)}
          >
            <span className="r1-choice-key" aria-hidden="true">
              {isSelected ? "✓" : (KEYS[i] ?? "•")}
            </span>
            <span className="flex flex-col">
              <span className="font-medium">{o.label ?? o.value}</span>
              {o.description ? (
                <span className="text-sm text-ink-muted">{o.description}</span>
              ) : null}
            </span>
          </button>
        );
      })}
    </div>
  );
}
